module.exports = __webpack_public_path__ + "static/media/en.a9fdb398.svg";